import { AuthUser, IAuthAdapter } from "~/core/domain/services/i-auth-adapter";

/**
 * モック認証アダプターの実装
 */
export class MockAuthAdapter implements IAuthAdapter {
  async getAccessToken(request?: Request): Promise<string | undefined> {
    if (request) {
      throw new Error("クライアントサイドではRequestオブジェクトは不要です");
    }

    return import.meta.env.VITE_MOCK_AUTH_TOKEN || "mock-access-token";
  }

  async getUser(request?: Request): Promise<AuthUser | null> {
    if (request) {
      throw new Error("クライアントサイドではRequestオブジェクトは不要です");
    }

    const userId =
      import.meta.env.VITE_MOCK_AUTH_USER_ID ||
      "00000000-0000-0000-0000-000000000000";
    const userEmail =
      import.meta.env.VITE_MOCK_AUTH_USER_EMAIL || "mock-user@example.com";

    return {
      id: userId,
      email: userEmail,
    };
  }
}
